import createPersistedState from 'vuex-persistedstate';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import auth from './auth';
import cart from './modules/cart';
import notification from './modules/notification';

Vue.use(Vuex);

const cartState = new createPersistedState({
  paths: ['cart'],
});

export default new Vuex.Store({
  state: {
    showShoppingBag: false,
    showSideMenu: false,
    newAddress: null,

    shop: null,
  },
  getters: {
    newAddress(state) {
      return state.newAddress;
    },

    shop(state) {
      return state.shop;
    },

    isGermany(state) {
      return state.shop ? state.shop.slug === 'samde' : false;
    },

    isItaly(state) {
      return state.shop ? state.shop.slug === 'samit' : false;
    },
  },
  mutations: {
    TOGGLE_SHOPPING_BAG(state) {
      state.showShoppingBag = !state.showShoppingBag;
    },

    CLOSE_SHOPPING_BAG(state) {
      state.showShoppingBag = false;
    },

    TOGGLE_MENU(state) {
      state.showSideMenu = !state.showSideMenu;
    },

    ADD_NEW_ADDRESS(state, value) {
      state.newAddress = value;
    },

    SET_SHOP(state, value) {
      state.shop = value;
    },
  },
  actions: {
    toggleShoppingBag({ commit }) {
      commit('TOGGLE_SHOPPING_BAG');
    },

    closeShoppingBag({ commit }) {
      commit('CLOSE_SHOPPING_BAG');
    },

    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },

    addNewAddress({ commit }, value) {
      commit('ADD_NEW_ADDRESS', value);
    },

    getShop({ commit }) {
      return axios.get('/api/shop')
        .then(({ data }) => {
          commit('SET_SHOP', null);
          commit('SET_SHOP', data);
        }).catch(() => {
          commit('SET_SHOP', null);
        });
    },
  },
  modules: {
    auth,
    cart,
    notification,
  },
  plugins: [cartState],
});
